import { render, staticRenderFns } from "./PanelComentarios.vue?vue&type=template&id=edeb24b2&scoped=true&"
import script from "./PanelComentarios.vue?vue&type=script&lang=js&"
export * from "./PanelComentarios.vue?vue&type=script&lang=js&"
import style0 from "./PanelComentarios.vue?vue&type=style&index=0&id=edeb24b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edeb24b2",
  null
  
)

export default component.exports